import { FileDto } from "./FileDto";
import { StockBooking } from "./StockBooking";

export class OrderPosition {

    constructor(){
        this.stockBookings = [];
    }

    id: string;
    orderId: string;
    positionNumber: number;
    skuId: string;
    discountPercent: number;
    discount: number;
    skuNumber: string;
    skuShortName: string;
    skuName1: string;
    skuDescription: string;
    netPrice: number;
    grossPrice: number;
    // Backend #525: uppercase ISO 4217 currency of all the amounts (snapshot; carried, never converted).
    currency: string = 'EUR';
    unitNetPrice: number;
    unitGrossPrice: number;
    vatPercentage: number;
    vatAmount: number;
    vatId: number;
    stockBookings: StockBooking[];
    status: string;
    quantity: number;
    files: FileDto[] = [];
}